import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'materialize-css/dist/js/materialize.min';
import 'smart-app-banner/dist/smart-app-banner.css';
import http_client from './services/http_client';
import MainSlot from './components/MainSlot';
import VueMeta from 'vue-meta';
import firebaseMessaging from './services/firebase.js';
import VueI18n from 'vue-i18n';
import messages from './langs/messages';

Vue.use(VueI18n);
Vue.config.productionTip = false;
Vue.prototype.$http = http_client;
Vue.component('MainSlot', MainSlot);
Vue.use(VueMeta, {
    tagIDKeyName: 'vmid',
    attribute: 'data-vue-meta',
    refreshOnceOnNavigation: true
});
Vue.prototype.$messaging = firebaseMessaging;

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages
})

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app')
